import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as TableCollapseIcon } from '@assets/svg/ic-tableCollapse.svg';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const TableFacilityGroupsSkeleton = () => {
  return [...Array(5)].map(() => (
    <tr key={uuidv4()}>
      <td className={style.tdWithDetails}>
        <TableCollapseIcon className={style.arrowDetailsIcon} />
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td />
    </tr>
  ));
};

export default TableFacilityGroupsSkeleton;
